
import { Loader } from "@googlemaps/js-api-loader"
import { getImgUrl } from "@/plugins/website"
const DEFAULT_POSITION = {
  LAT: 22.282998,
  LNG: 114.133834
}
const ZOOM_LEVEL = 15
export default {
  props: {
    storeList: {
      type: Array,
      default: () => []
    },
    currentStoreId: {
      type: Number,
      default: null
    },
    services: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      map: null,
      googlemaps: null,
      infoWindows: [],
      loader: new Loader({
        apiKey: this.$appConfig.googleMapApiKey,
        version: "weekly",
        libraries: ["places"]
      }),
      markers: [],
      selectIcon: getImgUrl("711StoreMarkerSelect.svg"), // URL for the selected icon
      defaultIcon: getImgUrl("711StoreMarker.svg")
    }
  },
  computed: {
    currentStore() {
      return (
        this.storeList.find(item => item.storeId == this.currentStoreId) ||
        this.storeList?.[0] || {
          latitude: DEFAULT_POSITION.LAT,
          longitude: DEFAULT_POSITION.LNG
        }
      )
    }
  },
  watch: {
    currentStoreId() {
      this.infoWindows.forEach(infoWindow => {
        if (infoWindow.id != this.currentStoreId) {
          infoWindow.close()
        } else {
          infoWindow.open({
            anchor: infoWindow.marker,
            map: this.map
          })
        }
      })
      if (this.map) {
        this.map.setCenter({
          lat: this.currentStore.latitude,
          lng: this.currentStore.longitude
        })
      }
      // Update marker icons
      this.markers.forEach(marker => {
        if (marker.id == this.currentStoreId) {
          marker.setIcon(this.selectIcon)
        } else {
          marker.setIcon(this.defaultIcon)
        }
      })
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    async initMap() {
      const googlemaps = await this.loader.importLibrary("maps")
      const { Marker } = await this.loader.importLibrary("marker")
      this.googlemaps = googlemaps
      this.Marker = Marker
      const mapOptions = {
        zoom: ZOOM_LEVEL,
        fullscreenControl: false,
        mapTypeControl: false,
        mapId: "4504f8b37365c3d0",
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP
        }
      }
      this.map = new this.googlemaps.Map(this.$refs.map, {
        center: { lat: this.currentStore.latitude, lng: this.currentStore.longitude },
        ...mapOptions
      })
      this.addWellcomeMarker()
    },

    addWellcomeMarker() {
      const locations = this.storeList.map(item => {
        return {
          lat: item.latitude,
          lng: item.longitude,
          id: item.storeId
        }
      })
      locations.forEach(location => {
        this.addMarker(location)
      })
      this.markers[0].setIcon(this.selectIcon)
      if (this.infoWindows.length > 0) {
        this.infoWindows[0].open({
          anchor: this.infoWindows[0].marker,
          map: this.map
        })
      }
    },
    getServiceImgUrl(id) {
      return this.services.find(item => item.id == id)?.imgUrl
    },
    addMarker(location) {
      const marker = new this.Marker({
        position: location,
        map: this.map,
        icon: this.defaultIcon,
        id: location.id
      })
      this.markers.push(marker)
      const storeInfo = this.storeList.find(item => item.storeId == location.id)
      let imgs = ""
      let serviceTemplate = ""
      if (storeInfo.serviceIds) {
        imgs = storeInfo.serviceIds
          .map(id => {
            const imgUrl = this.getServiceImgUrl(id)
            return imgUrl ? `<img src="${imgUrl}" alt="service" class="service-img" />` : ""
          })
          .join("")
      }
      if (imgs) {
        serviceTemplate = `
        <div class="title">Service</div>
        <div class="info group-wrapper">
          <div class="group">
            ${imgs}
          </div>
        </div>
        `
      }

      const contentString = `
  <div class="store-locator-store-info" style="width: 3rem;">
    <div>
      <div class="name">${storeInfo.storeName}</div>
      <div class="address">${storeInfo.storeAddress}</div>
    </div>
    <div>
      <div class="opening-hours">
        <svg  class="icon" width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path d="M11.7841 3.27791C11.6434 3.41883 11.4524 3.49802 11.2533 3.49802L9.25001 3.49805C8.8358 3.49806 8.50001 3.16228 8.5 2.74806C8.49999 2.33385 8.83578 1.99806 9.24999 1.99805L9.46966 1.99805C9.39751 1.96544 9.32327 1.9387 9.24877 1.91187C9.18379 1.88847 9.11861 1.86499 9.05448 1.8375C8.48363 1.59277 7.79631 1.49805 7.05 1.49805C3.94864 1.49805 1.5 3.87851 1.5 6.94999C1.5 10.0529 3.88006 12.502 6.95 12.502C10.0356 12.502 12.5 10.0371 12.5 6.94999C12.5 6.21642 12.4089 5.6241 12.1606 5.04466C11.9975 4.66392 12.1739 4.22303 12.5546 4.05991C12.9354 3.89678 13.3656 4.04838 13.5394 4.45394C13.8911 5.27494 14 6.08306 14 6.94999C14 10.8651 10.8644 14.002 6.95 14.002C3.01994 14.002 0 10.8493 0 6.94999C0 3.01927 3.15136 -0.00195211 7.05 -0.00195211C7.89321 -0.00195211 8.79399 0.100821 9.61497 0.44588C9.90694 0.542267 10.2659 0.718743 10.5002 0.876192L10.5 0.749279C10.4993 0.335066 10.8346 -0.00126958 11.2488 -0.00195211C11.663 -0.00262658 11.9993 0.332609 12 0.746822L12.0033 2.74679C12.0036 2.94591 11.9247 3.13699 11.7841 3.27791Z"/><path d="M7 4C7.41421 4 7.75 4.33579 7.75 4.75V7.01794C7.75 7.18067 7.82919 7.33322 7.96227 7.42686L9.68159 8.63663C10.0203 8.87499 10.1017 9.34283 9.86338 9.68159C9.62502 10.0203 9.15717 10.1017 8.81841 9.86338L6.56841 8.28021C6.36878 8.13974 6.25 7.91092 6.25 7.66683V4.75C6.25 4.33579 6.58579 4 7 4Z"/></svg>
        <span>${this.$t("storeLocator.openingHours")}</span>
      </div>
      <div class="opening-hours-text">${storeInfo.openingHours.replace(/\n/g, "<br />")}</div>
    </div>
    <div>
      ${serviceTemplate}
      <a class="direction" target="_blank" href="https://www.google.com/maps/dir/Current+Location/${
        storeInfo.storeAddress
      }">
      ${this.$t("storeLocator.getDirections")}
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.3333 7.99622C11.3333 8.10884 11.3083 8.22147 11.2666 8.32543C11.2165 8.43805 11.1498 8.53335 11.0663 8.61999L5.99333 13.7661C5.85149 13.922 5.65958 14 5.45099 14C5.30914 14 5.17564 13.9653 5.05883 13.896C4.94202 13.8267 4.85024 13.7228 4.77514 13.6101C4.70005 13.4889 4.66668 13.3502 4.66668 13.203C4.66668 12.9777 4.75011 12.7698 4.90864 12.6138L9.47268 7.99622L4.90865 3.37859C4.75846 3.23131 4.66668 3.01472 4.66668 2.79814C4.66668 2.65086 4.70005 2.51224 4.77515 2.39095C4.8419 2.26967 4.94202 2.17437 5.05883 2.10506C5.17565 2.03575 5.31749 1.99243 5.45099 2.0011C5.65124 2.0011 5.85149 2.07907 5.99333 2.23501L11.0663 7.37245C11.1498 7.45042 11.2165 7.55438 11.2666 7.65834C11.3083 7.7623 11.3333 7.88359 11.3333 7.99622Z" fill="currentColor"/>
      </svg>

      </a>
    </div>
  </div>
     `

      const infowindow = new this.googlemaps.InfoWindow({
        content: contentString,
        shouldFocus: true,
        id: location.id
      })
      infowindow.marker = marker

      marker.addListener("click", event => {
        this.closeInfoWindows()
        this.$emit("change", infowindow.id)
        infowindow.open({
          anchor: marker,
          map: this.map,
          shouldFocus: true
        })
      })
      this.infoWindows.push(infowindow)
    },
    closeInfoWindows() {
      this.infoWindows.forEach(infoWindow => {
        infoWindow.close()
      })
    }
  }
}
